import { Component, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import type { FormControl } from '@angular/forms';

import { startWith, switchMap } from 'rxjs';

import { RadioComponent } from '@core/user-interface-legacy';
import type { EvaluationChoiceOption } from '@recruitee/evaluations-types';

@Component({
  selector: 'rt-evaluation-single-choice-field',
  templateUrl: './evaluation-single-choice-field.component.html',
  styleUrls: ['./evaluation-single-choice-field.component.less'],
  imports: [RadioComponent],
})
export class EvaluationSingleChoiceFieldComponent {
  public readonly control = input.required<FormControl<string | number | null>>();
  public readonly options = input<EvaluationChoiceOption[]>([]);

  protected value = toSignal(
    toObservable(this.control).pipe(
      switchMap(control => control.valueChanges.pipe(startWith(control.value))),
    ),
    { initialValue: null },
  );

  protected select(value: string | number): void {
    const control = this.control();

    control.setValue(value);
    control.markAsDirty();
    control.markAsTouched();
  }
}
